@if (getErrors()) {
  <mat-error class="error-field">
    {{getErrors()[0]}}
  </mat-error>
}
